import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-delivery-method-langs',
  templateUrl: './delivery-method-langs.component.html',
  styleUrls: ['./delivery-method-langs.component.css'],
  standalone: false
})
export class DeliveryMethodLangsComponent implements OnInit {
    deliveryMethodNo;

    public inputListLanguages: InputLanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.deliveryMethodNo = this.stateService.getStateParams()['deliverymethod_no'];
    }

    private async loadLanguages() {
        if (!!this.deliveryMethodNo) {
            this.inputListLanguages = await this.datatask.Post(2175, { deliverymethod_no: this.deliveryMethodNo });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2176, { records: this.inputListLanguages }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface InputLanguageItem {
    deliverymethod_no: number;
    deliverymethod_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryMethodLangs', {
//        templateUrl: 'views/components/views/deliveryMethodLangs/deliveryMethodLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'deliveryMethodLangsService', function ($stateParams, stateService, modalService, translateService, deliveryMethodLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let deliveryMethodNo = $stateParams.deliverymethod_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadDeliveryMethodLanguages() {
//                vm.model.inputListLanguages = (await deliveryMethodLangsService.listDeliveryMethodLanguages({ deliverymethod_no: deliveryMethodNo }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                deliveryMethodLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadDeliveryMethodLanguages();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
